var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5634",
    "data-name": "Group 5634",
    transform: "translate(0.147 0.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    transform: "translate(-0.147 -0.146)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633",
    transform: "translate(6.285 6.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M5,12h6.556",
    transform: "translate(-5 -9.486)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M15,14.514,17.514,12",
    transform: "translate(-10.957 -9.486)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M15,8l2.514,2.514",
    transform: "translate(-10.957 -8)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.0e661734.svg";
export { ForwardRef as ReactComponent };